import { render, staticRenderFns } from "./ClinicOrderComplete.vue?vue&type=template&id=10a51b40&scoped=true&"
import script from "./ClinicOrderComplete.vue?vue&type=script&lang=js&"
export * from "./ClinicOrderComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a51b40",
  null
  
)

export default component.exports